// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — options-toggles.styled.classic.js, новая — options-toggles.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './options-toggles.styled.classic';
import * as cp from './options-toggles.styled.cp';

export const Slider = isCp ? cp.Slider : classic.Slider;
export const SwitchInput = isCp ? cp.SwitchInput : classic.SwitchInput;
export const ToggleWrapper = isCp ? cp.ToggleWrapper : classic.ToggleWrapper;
